import React from "react";
import { Loader2 } from "lucide-react";

const ConfirmPayPrimaryButton: React.FC<{
  label: string;
  isLoading: boolean;
  onClick: () => void;
}> = ({ label, isLoading, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={isLoading}
    className="flex h-14 w-full items-center justify-center rounded-xl bg-brand-dark text-16 font-semibold text-white active:opacity-90 disabled:opacity-80"
  >
    {isLoading ? <Loader2 className="h-5 w-5 animate-spin" /> : label}
  </button>
);

export default ConfirmPayPrimaryButton;
